<template>
    <div class="member">
        <el-avatar :size="50" :src="value.avatar"></el-avatar>
        <div class="info">
            <div>{{ value.nickName }}({{value.id}})</div>
            <div>{{ value.mobile }}</div>
        </div>
    </div>
</template>

<script>

export default{
     props: {
        value: {
            type: Object
        },
    },
    data(){
        return{

        }
    }
}
</script>

<style scoped lang="scss">
.member{
  width: 150px;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  el-avatar{
    width: 50px;
    height: 50px;
  }
  .info{
    width: 100px;
    margin-left: 8px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
  }
}
</style>